module.exports = __webpack_public_path__ + "cornerSprite-c72260126bd6814b73b8dd4cfbd1baf8.png";